var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.46,
    height: 72.676,
    viewBox: "0 0 23.14 19.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M155.771 26.331C69.74 26.331 0 96.071 0 182.102c0 37.488 13.25 71.883 35.314 98.761 3.404-27.256 30.627-50.308 68.8-61.225 13.946 12.994 31.96 20.878 51.656 20.878 19.233 0 36.894-7.487 50.698-19.936 38.503 11.871 65.141 36.27 66.017 64.63 24.284-27.472 39.056-63.555 39.056-103.108 0-86.031-69.74-155.771-155.77-155.771zm0 195.738c-9.944 0-19.314-2.732-27.634-7.464-20.05-11.409-33.855-34.756-33.855-61.711 0-38.143 27.583-69.176 61.489-69.176 33.909 0 61.489 31.033 61.489 69.176 0 27.369-14.237 51.004-34.786 62.215-8.095 4.414-17.128 6.96-26.703 6.96z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "translate(0 -1.956) scale(.07428)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.e678bd779792960393bcd80f376c2697.svg";
export { ForwardRef as ReactComponent };